import { OrganizationUser } from "@organization/models/OrganizationUser";

export function filterOrganizationUsers(
  users: OrganizationUser[] | undefined,
  value: string | undefined
): OrganizationUser[] {
  if (!users) return [];

  if (!value) return users;

  const val = value.toLocaleLowerCase();

  return users.filter(item => {
    const { displayName, emailAddress, organizationRole } = item;

    const A = displayName.toLocaleLowerCase().includes(val);
    const B = emailAddress.toLocaleLowerCase().includes(val);
    const C = organizationRole.toLocaleLowerCase().includes(val);

    return A || B || C;
  });
}
